import React from 'react';
import { EdgeProps, getBezierPath, useReactFlow } from 'reactflow';

import usePlaceholderClick from '../hooks/usePlaceholderClick';
import styles from './EdgeTypes.module.css';

const WorkflowEdge: React.FC<EdgeProps> = ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style,
    markerEnd,
    source
}) => {

    // see the hook for implementation details
    // onClick adds a placeholder node to the parent node and as a sibling
    const handleClick = usePlaceholderClick(id.split('=>')[0]);
    const { getNode } = useReactFlow();

    const [edgePath, edgeCenterX, edgeCenterY] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    const sourceNode = getNode(source); // Get source node details
    const isEvaluatorNode = sourceNode?.type === 'evaluatorNode';

    return (
        <>
            <path
                id={id}
                style={style}
                className={styles.edgePath}
                d={edgePath}
                markerEnd={markerEnd}
            />
            {!isEvaluatorNode && <g transform={`translate(${edgeCenterX}, ${edgeCenterY})`}>
                <rect
                    onClick={() => handleClick('requestNode', undefined, true)}
                    x={-10}
                    y={-10}
                    width={20}
                    ry={4}
                    rx={4}
                    height={20}
                    className={styles.edgeButton}
                />
                <text className={styles.edgeButtonText} y={5} x={-4}>
                    +
                </text>
            </g>}
        </>
    )
}

export default WorkflowEdge